"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nav = void 0;
var react_1 = __importStar(require("react"));
var index_css_1 = __importDefault(require("./index.css"));
var react_router_dom_1 = require("react-router-dom");
var menu_png_1 = __importDefault(require("../../static/images/menu.png"));
var recoil_1 = require("recoil");
var login_1 = require("../../hooks/login");
var login_btn_1 = require("../login-btn");
var logout_btn_1 = require("../logout-btn");
var texts_1 = require("../../ui/texts");
function Nav() {
    var _a = (0, react_1.useState)(false), showMenu = _a[0], setShowMenu = _a[1];
    function toggleMenu() {
        setShowMenu(!showMenu);
    }
    return (react_1.default.createElement("nav", null,
        react_1.default.createElement("img", { src: menu_png_1.default, onClick: toggleMenu, alt: "menu-button", className: index_css_1.default.burger }),
        showMenu ? react_1.default.createElement(Menu, { cb: toggleMenu }) : ""));
}
exports.Nav = Nav;
function Menu(_a) {
    var cb = _a.cb;
    var loginStateValue = (0, recoil_1.useRecoilValue)(login_1.loginState);
    return (react_1.default.createElement("div", { className: index_css_1.default.menu },
        react_1.default.createElement("ul", null,
            react_1.default.createElement("li", { className: index_css_1.default.home },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/", onClick: cb },
                    react_1.default.createElement(texts_1.SubtitleBold, null, "Home"))),
            react_1.default.createElement("li", { className: index_css_1.default.datos },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/mis-datos", onClick: cb },
                    react_1.default.createElement(texts_1.SubtitleBold, null, "Mis datos"))),
            react_1.default.createElement("li", { className: index_css_1.default.mascotas },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/mis-mascotas", onClick: cb },
                    react_1.default.createElement(texts_1.SubtitleBold, null, "Mis mascotas reportadas"))),
            react_1.default.createElement("li", { className: index_css_1.default.reportar },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/reportar-mascota", onClick: cb },
                    react_1.default.createElement(texts_1.SubtitleBold, null, "Reportar mascota")))),
        react_1.default.createElement("div", { className: index_css_1.default.session, onClick: cb }, loginStateValue ? react_1.default.createElement(logout_btn_1.LogoutButton, null) : react_1.default.createElement(login_btn_1.LoginButton, null))));
}
